<template>
  <Layout title="Transport Voucher" description="Review and manage transport vouchers">
    <div class="container py-5" style="max-width: 1100px;">
      <div class="card shadow">
        <div class="card-header bg-dark text-light d-flex justify-content-between align-items-center">
          <div>
            <h3 class="mb-0">Transport Voucher</h3>
            <small class="text-muted">Fill in and save the transport voucher below</small>
          </div>
        </div>

        <div class="card-body">
          <!-- VOUCHER CANVAS -->
          <div class="row g-3 mb-4">
            <div class="col-lg-8 text-center mx-auto">
              <canvas
                ref="voucherCanvas"
                class="border rounded bg-white w-100"
                style="max-width: 750px; height: auto;"
              ></canvas>
            </div>
          </div>
          <div class="row g-2 mb-4 small">
            <div class="col-md-4"><label>Vessel</label><input v-model="form.vessel" class="form-control form-control-sm" /></div>
            <div class="col-md-4"><label>PIC</label><input v-model="form.pic" class="form-control form-control-sm" /></div>
            <div class="col-md-4"><label>Driver</label><input v-model="form.driver" class="form-control form-control-sm" /></div>
            <div class="col-md-4"><label>Date</label><input v-model="form.date" class="form-control form-control-sm" /></div>
            <div class="col-md-4"><label>Time</label><input v-model="form.time" class="form-control form-control-sm" /></div>
            <div class="col-md-4"><label>Vehicle No.</label><input v-model="form.vehicleNo" class="form-control form-control-sm" /></div>
            <div class="col-md-6"><label>From</label><input v-model="form.from" class="form-control form-control-sm" /></div>
            <div class="col-md-6"><label>To</label><input v-model="form.to" class="form-control form-control-sm" /></div>
            <div class="col-md-4"><label>Crew</label><input v-model="form.crew" class="form-control form-control-sm" /></div>
            <div class="col-md-4"><label>Pax</label><input v-model="form.pax" class="form-control form-control-sm" /></div>
            <div class="col-md-4"><label>Flight</label><input v-model="form.flight" class="form-control form-control-sm" /></div>
            <div class="col-12"><label>Remarks</label><textarea v-model="form.remarks" class="form-control form-control-sm"></textarea></div>
          </div>

          <!-- CHARGES SECTION -->
            <hr class="my-4" />
            <h5 class="fw-bold mb-3">Charges (SGD)</h5>

            <!-- SWITCHES + VALUES -->
            <div class="row g-3 small align-items-center">
              <!-- Switches -->
              <div class="col-md-12 mb-2">
                <div class="d-flex flex-wrap gap-3">
                  <div v-for="(label, key) in switches" :key="key" class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" v-model="form[key]" :id="key">
                    <label class="form-check-label" :for="key">{{ label }}</label>
                  </div>
                </div>
              </div>

              <!-- Values -->
              <div class="col-md-4" v-for="(label, key) in fields" :key="key">
                <label>{{ label }}</label>

                <!-- if waitingValue, string -->
                <input
                  v-if="key === 'waitingValue'"
                  v-model="form[key]"
                  type="text"
                  class="form-control form-control-sm"
                />

                <!-- all others number -->
                <input
                  v-else
                  v-model.number="form[key]"
                  type="number"
                  min="0"
                  class="form-control form-control-sm"
                />
              </div>


              <!-- <div class="col-md-4">
                <label class="fw-bold">Total SGD</label>
                <input v-model.number="form['totalSGD']" class="form-control form-control-sm"/>
              </div> -->

              <!-- SIGNATURE SECTION -->
              <hr class="my-4" />
                <h5 class="fw-bold mb-2">Signature</h5>
                <div class="text-center">
                  <canvas
                    ref="signaturePad"
                    class="border rounded bg-white w-100"
                    style="max-width: 750px; height: 130px;"
                    @mousedown="startSign"
                    @mousemove="drawSign"
                    @mouseup="endSign"
                    @mouseleave="endSign"
                    @touchstart.prevent="startSign"
                    @touchmove.prevent="drawSign"
                    @touchend.prevent="endSign"
                  ></canvas>
                  <button class="btn btn-sm btn-outline-secondary mt-2" @click="clearSign">Clear Signature</button>
              </div>

              <div class="col-12 text-center mt-3">
                <button class="btn btn-primary px-4" @click="replaceVoucher" :disabled="isUploading">
                  <span v-if="!isUploading">Save Image</span>
                  <span v-else class="spinner-border spinner-border-sm"></span>
                </button>
              </div>
            </div>

        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/components/Layout.vue'
import axios from 'axios'
import { useToast } from 'vue-toastification'
import { getAuth,onAuthStateChanged } from 'firebase/auth'
import router from '@/router'

export default {
  name: 'VoucherPage',
  components: { Layout },
  data() {
    return {
      voucherId: '',
      voucherImg: require('@/assets/transportVoucher.jpg'),
      scaleFactor: 0.9,
      isUploading: false,
      // ✅ all editable fields combined (info + charges)
      form: {
            // info
            vessel: '',
            pic: '',
            driver: '',
            date: '',
            time: '',
            vehicleNo: '',
            from: '',
            to: '',
            crew: '',
            pax: '',
            flight: '',
            remarks: '',
            remarks2: '',
            totalSGD:"",
            // charges
            tripValue: 0,
            erpValue: 0,
            parkingValue: 0,
            meetingValue: 0,
            midnightValue: 0,
            waitingValue: '',
            othersValue: 0,
            voucherId:"",
            trip: true,
            erp: false,
            parking: false,
            meeting: false,
            midnight: false,
            waiting: false,
            others: false,
            createdBy:"admin"
      },
      fields: {
        tripValue: 'Trip',
        erpValue: 'ERP',
        parkingValue: 'Parking',
        meetingValue: 'Meeting',
        midnightValue: 'Midnight',
        waitingValue: 'Waiting',
        othersValue: 'Others'
      },
      switches: {
        trip: 'Trip',
        erp: 'ERP',
        parking: 'Parking',
        meeting: 'Meeting',
        midnight: 'Midnight',
        waiting: 'Waiting',
        others: 'Others'
      },

    }
  },
  setup() {
    const toast = useToast()
    return { toast }
  },
  
async mounted() {
  this.voucherId = this.$route.params.voucherId
  this.checkPageAccess(['admin'])

  const auth = getAuth()

  onAuthStateChanged(auth, async (user) => {
    if (user) {
      // ✅ user restored after refresh
      await this.fetchVoucher()
    } else {
      console.warn('⚠️ No user found, please login')
      this.toast.error('Please login again')
      router.push('/login') // or show a login modal
    }
  })

  // ✅ preload background voucher image
  const img = new Image()
  img.src = this.voucherImg
  img.onload = () => {
    this.voucherImg = img.src
    this.drawVoucher()
  }

  // ✅ redraw when values change
  Object.keys(this.form).forEach(key => {
    this.$watch(`form.${key}`, this.drawVoucher)
  })

  const c = this.$refs.signaturePad
  const rect = c.getBoundingClientRect()
  c.width = rect.width * window.devicePixelRatio
  c.height = rect.height * window.devicePixelRatio
  const ctx = c.getContext('2d')
  ctx.scale(window.devicePixelRatio, window.devicePixelRatio)

},
  computed: {
    calcTotalSGD() {
      return (
        Number(this.form.tripValue) +
        Number(this.form.erpValue) +
        Number(this.form.parkingValue) +
        Number(this.form.meetingValue) +
        Number(this.form.midnightValue) +
        Number(this.form.othersValue)
      ).toFixed(2)
    }
  },
  methods: {
    async getAuthHeader() {
      const auth = getAuth()
      const user = auth.currentUser
      if (!user) throw new Error('Not logged in')
      const token = await user.getIdToken(true)
      return { Authorization: token }
    },
    

    checkPageAccess(allowedRoles = []) {
      const access = this.$store.state.systemAccess || {}
      const hasAccess = allowedRoles.some(role => access[role] === true)
      if (!hasAccess) {
        this.$toast.error('Access denied.')
        if (access.admin) this.$router.push('/crm')
        else if (access.client) this.$router.push('/booking')
        else if (access.driver) this.$router.push('/jobManagement')
        else this.$router.push('/')
      }
    },
    async fetchVoucher() {
      try {
        if (!this.voucherId) return

        const headers = await this.getAuthHeader()
        const res = await axios.get(`${this.$apiURL}/api/vouchers/${this.voucherId}`, { headers })

        if (res.data?.voucherData) {
          const v = res.data.voucherData

          // ✅ fill in all info + charge fields
          this.form = {
            vessel: v.vessel || '',
            pic: v.pic || '',
            driver: v.driver || '',
            date: v.date || '',
            time: v.time || '',
            vehicleNo: v.vehicleNo || '',
            from: v.from || '',
            to: v.to || '',
            crew: v.crew || '',
            pax: v.pax || '',
            flight: v.flight || '',
            remarks: v.remarks || '',
            remarks2: v.remarks2 || '',
            tripValue: v.tripValue || 0,
            erpValue: v.erpValue || 0,
            parkingValue: v.parkingValue || 0,
            meetingValue: v.meetingValue || 0,
            midnightValue: v.midnightValue || 0,
            waitingValue: v.waitingValue || 0,
            othersValue: v.othersValue || 0,
            totalSGD:v.totalSGD || 0, 
            
            // ✅ boolean switches (make sure to coerce to true/false)
            trip: !!v.trip,
            erp: !!v.erp,
            parking: !!v.parking,
            meeting: !!v.meeting,
            midnight: !!v.midnight,
            waiting: !!v.waiting,
            others: !!v.others,
            createdBy: v.createdBy
          }
          this.signatureUrl = res.data.signatureUrl || ''
          // 🖊️ optional — draw the old signature if got
          if (this.signatureUrl) {
            const img = new Image()
            img.crossOrigin = 'anonymous'
            img.src = this.signatureUrl
            img.onload = () => {
              const c = this.$refs.signaturePad
              const ctx = c.getContext('2d')
              const rect = c.getBoundingClientRect()
              ctx.drawImage(img, 0, 0, rect.width, rect.height)
              // 🔥 Now the signaturePad is ready → draw voucher again
              this.$nextTick(() => {
                this.drawVoucher()
              })
            }
          }
          this.$nextTick(this.drawVoucher)
        } else {
          this.toast.error('Voucher not found')
        }
      } catch (err) {
        console.error('❌ fetchVoucher error:', err)
        this.toast.error('Error loading voucher data')
      }
    },

    drawVoucher() {
      if (!this.voucherImg) return
      const canvas = this.$refs.voucherCanvas
      const img = new Image()
      img.crossOrigin = 'anonymous'
      img.src = this.voucherImg

      img.onload = () => {
        const ctx = canvas.getContext('2d')
        canvas.width = img.width * this.scaleFactor
        canvas.height = img.height * this.scaleFactor
        ctx.scale(this.scaleFactor, this.scaleFactor)
        ctx.drawImage(img, 0, 0)
        ctx.fillStyle = 'blue'
        if (this.form.createdBy == "admin"){
          ctx.fillStyle = 'red'
        }

        ctx.font = '20px Arial'
        ctx.fillText(`${this.voucherId || ''}`, 980, 70)

        ctx.fillStyle = 'black'
        ctx.font = '25px Arial'


        // ✅ Basic Info Section
        ctx.fillText(`${this.form.vessel || ''}`, 130, 170)
        ctx.fillText(`${this.form.pic || ''}`, 540, 170)
        ctx.fillText(`${this.form.driver || ''}`, 980, 170)
        ctx.fillText(`${this.form.vehicleNo || ''}`, 1010, 230)
        ctx.fillText(`${this.form.date || ''}`, 130, 230)
        ctx.fillText(`${this.form.time || ''}`, 560, 230)
        ctx.fillText(`${this.form.from || ''}`, 130, 290)
        ctx.fillText(`${this.form.to || ''}`, 540, 290)
        ctx.fillText(`${this.form.crew || ''}`, 270, 350)
        ctx.fillText(`${this.form.pax || ''}`, 780, 345)
        ctx.fillText(`${this.form.flight || ''}`, 1000, 345)
        ctx.fillText(`${this.form.remarks || ''}`, 150, 405)
        ctx.fillText(`${this.form.remarks2 || ''}`, 150, 455)

        // ✅ Charges Section
        ctx.fillText(this.form.trip? '✔' : '', 290, 520)
        ctx.fillText(this.form.erp? '✔' : '', 290, 560)
        ctx.fillText(this.form.parking? '✔' : '', 290, 595)
        ctx.fillText(this.form.meeting? '✔' : '', 290, 635)
        ctx.fillText(this.form.midnight? '✔' : '', 290, 675)
        ctx.fillText(this.form.waiting? '✔' : '', 290, 710)
        ctx.fillText(this.form.others? '✔' : '', 290, 750)
        
        // ctx.fillText(`${this.form.totalSGD}`, 950, 810)
        // ✅ draw signature if available
        // if (this.signatureUrl) {
        //   const sigImg = new Image()
        //   sigImg.crossOrigin = 'anonymous'
        //   sigImg.src = this.signatureUrl
        //   sigImg.onload = () => {
        //     // position the signature nicely — adjust (x, y, width, height)
        //     const sigX = 800
        //     const sigY = 510
        //     const sigWidth = 300
        //     const sigHeight = 120
        //     ctx.drawImage(sigImg, sigX, sigY, sigWidth, sigHeight)
        //   }
        // }
        const signCanvas = this.$refs.signaturePad
        if (signCanvas) {
          const sigImg = new Image()
          sigImg.src = signCanvas.toDataURL('image/png')
          sigImg.onload = () => {
            const sigX = 800
            const sigY = 510
            const sigWidth = 300
            const sigHeight = 120
            ctx.drawImage(sigImg, sigX, sigY, sigWidth, sigHeight)
          }
        }

      }
    },
    startSign(e) {
      const c = this.$refs.signaturePad
      this.signCtx = c.getContext('2d')
      this.signCtx.strokeStyle = 'black'
      this.signCtx.lineWidth = 2

      const rect = c.getBoundingClientRect()
      const pos = e.touches ? e.touches[0] : e
      const x = pos.clientX - rect.left
      const y = pos.clientY - rect.top

      this.signing = true
      this.signCtx.beginPath()
      this.signCtx.moveTo(x, y)
      this.signCtx.lineTo(x + 0.1, y + 0.1)
      this.signCtx.stroke()
    },

    drawSign(e) {
      if (!this.signing) return
      const c = this.$refs.signaturePad
      const rect = c.getBoundingClientRect()
      const pos = e.touches ? e.touches[0] : e
      const x = pos.clientX - rect.left
      const y = pos.clientY - rect.top
      this.signCtx.lineTo(x, y)
      this.signCtx.stroke()
    },

    endSign() {
      if (!this.signing) return
      this.signing = false
      this.signCtx.closePath()

      // 🔥 FORCE redraw voucher with new signature
      this.drawVoucher()
    },

    clearSign() {
      const c = this.$refs.signaturePad
      const ctx = c.getContext('2d')
      ctx.clearRect(0, 0, c.width, c.height)

      this.drawVoucher()
    },

    async replaceVoucher() {
      if (!this.voucherId) {
        this.toast.error('Missing voucher ID')
        return
      }

      this.isUploading = true
      try {
        const headers = await this.getAuthHeader()
        const formData = new FormData()

        Object.entries(this.form).forEach(([key, value]) => {
          formData.append(key, value ?? 0)
        })
        const sigCanvas = this.$refs.signaturePad
        const sigBlob = await new Promise(resolve => sigCanvas.toBlob(resolve, 'image/png'))
        if (sigBlob) {
          formData.append('signature', sigBlob, `Signature_${this.voucherId}.png`)
        }

        const canvas = this.$refs.voucherCanvas
        const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png'))
        if (blob) formData.append('file', blob, `TransportVoucher_${this.voucherId}.png`)

        const res = await axios.put(
          `${this.$apiURL}/api/vouchers/${this.voucherId}/replace`,
          formData,
          { headers }
        )

        if (res.data.ok) {
          this.toast.success('Voucher updated successfully!')
          setTimeout(() => router.push('/JobManagement'), 800)
        } else {
          this.toast.error(res.data.error || 'Failed to update voucher.')
        }
      } catch (err) {
        console.error('❌ replaceVoucher error:', err)
        this.toast.error('Error updating voucher.')
      } finally {
        this.isUploading = false
      }
    }
  }
}
</script>

<style scoped>
canvas {
  touch-action: none;
}
@media (max-width: 768px) {
  .row.g-3.mb-4 {
    flex-direction: column !important;
  }
  canvas {
    height: auto !important;
  }
}
</style>
